<template>
  <v-card-text>
    <div class="add-price-result">
      <div class="result-card">
        <div class="relative">
          <div>{{factor_price}} {{ $t('factorPriceQ') }}</div>
          <br>
          <div>{{calculate_price}} {{ $t('totalPayQ') }}</div>
          <br>
          <v-menu
            bottom
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="ma-2"
                v-bind="attrs"
                v-on="on"
              >{{ $t('addPay') }}<v-icon>
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in pay_types"
                :key="i"
                @click="add_payment(item)"
              >
                <v-list-item-title>{{ item.PaymentTypeTitle }}</v-list-item-title>
              </v-list-item>
            </v-list>

          </v-menu>

          <v-list>
            <v-list-item
              v-for="(item, i) in prices"
              :key="i"
            >

              <v-list-item-title>{{ item.payment_name }} {{ item.price }} {{$t('currencyName')}}</v-list-item-title>
              <v-list-item-content>{{ item.price }}</v-list-item-content>
              <v-icon v-on:click="delete_price(i)">
                mdi-close
              </v-icon>
            </v-list-item>
          </v-list>

          <!--***************************************************-->

          <v-menu
            bottom
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="ma-2"
                v-bind="attrs"
                v-on="on"
              >{{ $t('addFile') }}<v-icon>
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                @click="select_file(i)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>

          </v-menu>

          <v-list>
            <input id="fileUpload" type="file" hidden v-on:change="input_file_changed">
            <v-list-item
              v-for="(item, i) in files"
              :key="i"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-img :src="item.file" width="200px" height="200px"/>
              <v-icon v-on:click="delete_file(i)">
                mdi-close
              </v-icon>
            </v-list-item>
          </v-list>
        </div>

      </div>
      <div class="text-center">
        <v-btn color="primary" v-on:click="save()">{{ $t('submitPays') }}</v-btn>
      </div>

    </div>

<!--    <div class="row login">-->

<!--      <v-row>-->
<!--       -->
<!--      </v-row>-->
<!--    </div>-->

    <v-row justify="center">
      <v-dialog
        v-model="dialog_camera"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="dialog_camera = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('camera') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                dark
                text
                @click="downloadImage()"
              >{{ $t('save') }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <div v-if="isCameraOpen" class="camera-box">
            <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="337.5" autoplay></video>
            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="337.5"></canvas>
          </div>
          <div v-if="isCameraOpen" class="camera-shoot">
            <v-btn type="button" class="button" @click="takePhoto">
              <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
            </v-btn>
          </div>
          <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
            <!--            <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">-->
            <!--              Download-->
            <!--            </a>-->
          </div>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="dialog_price"
        persistent
        max-width="290"

      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('receivedPrice') }}</v-card-title>
          <v-card-text>
            <v-row>

              <v-text-field
                :label="$t('insertAmount')"
                v-model="payment_price"
                outlined
                type="number"
              ></v-text-field>

            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="dialog_price = false"
            >{{ $t('cancel') }}</v-btn>
            <v-btn
              class="accept-btn"
              text
              @click="add_payment_to_list()"
            >{{ $t('ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card-text>

</template>

<script>
  import { bus } from '../../main'

  export default {
    name: 'Attachments',
    data () {
      return {
        files: [],
        prices: [],
        items: [
          // {
          //   title: 'دوربین',
          // },
          {
            title: 'گالری',
          },

        ],
        pay_types: [
          // {
          //   title: 'دوربین',
          // },
          {
            title: 'گالری',
          },

        ],
        dialog_camera: false,
        isCameraOpen: false,
        isPhotoTaken: false,
        payment_price: '',
        payment_name: '',
        payment_id: '',
        dialog_price: false,
        factor_price: '',
      }
    },
    watch: {},
    computed: {
      calculate_price () {
        var calculate_prices = 0
        for (var i = 0; i < this.prices.length; i++) {
          calculate_prices += parseInt(this.prices[i].price)
        }
        return calculate_prices
      }
    },
    mounted () {
      this.items= [
        // {
        //   title: 'دوربین',
        // },
        {
          title: this.$t('gallery'),
        },

      ];
       this.pay_types= [
        // {
        //   title: 'دوربین',
        // },
        {
          title: this.$t('gallery'),
        },

      ];
      this.get_payment_types()
      this.get_payment_info()
    },
    methods: {

      add_payment (item) {
        this.payment_id = item.PaymentTypeId
        this.payment_name = item.PaymentTypeTitle
        this.dialog_price = true
      },
      add_payment_to_list () {
        if (this.payment_price != '') {
          var obj = { price: this.payment_price, type_id: this.payment_id, payment_name: this.payment_name }
          this.prices.push(obj)
          this.payment_price = ''
          this.dialog_price = false
        }
      },
      select_file (index) {
        if (index == 0) {
          document.getElementById('fileUpload').click()

          // this.open_camera();
          // this.dialog_camera = true;
        }
        if (index == 1) {

        }
      },
       save () {
        if (this.calculate_price < this.factor_price) {
          bus.$emit('show_toast', [1500, this.$t('payedAmountLowThanFactor')])
        } else {
          if (this.files.length) {
            for (var i = 0; i < this.files.length; i++) {
              this.upload_image(i)
            }
          } else {
            for (var x = 0; x < this.prices.length; x++) {
              this.send_prices_to_server(x)
            }
          }
        }
      },
      open_camera () {
        this.isCameraOpen = true
        this.createCameraElement()
      },
      delete_file (index) {
        this.files.splice(index, 1)
      },
      delete_price (index) {
        this.prices.splice(index, 1)
      },
      takePhoto () {
        this.isPhotoTaken = true

        const context = this.$refs.canvas.getContext('2d')
        context.drawImage(this.$refs.camera, 0, 0, 450, 337.5)
      },
      downloadImage () {
        if (this.isPhotoTaken == true) {
          this.isCameraOpen = false
          // const download = document.getElementById("downloadPhoto");
          const preview = document.getElementById('photoTaken')
          const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
          // .replace("image/jpeg", "image/octet-stream");
          var obj = { file: canvas, preview: preview, upload: 0 }
          this.files.push(obj)
          this.dialog_camera = false
          this.isPhotoTaken = false
        }
        // download.setAttribute("href", canvas);
      },
      input_file_changed () {
        var self = this

        var reader = new FileReader()
        var f = document.getElementById('fileUpload').files

        reader.onloadend = function () {
          // console.log(reader.result);
          var obj = { file: reader.result, preview: reader.result, upload: 0 }
          self.files.push(obj)
        }
        reader.readAsDataURL(f[0])
      },
      createCameraElement () {
        try {
          const constraints = (window.constraints = {
            audio: false,
            video: true
          })

          navigator.mediaDevices
            .getUserMedia(constraints)
            .then(stream => {
              this.$refs.camera.srcObject = stream
            })
            .catch(error => {
              alert(this.$t('deviceHasNoCamera'))
            })
        } catch (err) {
          alert(err)
        }
      },
      upload_image (index) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var form_data = new FormData()
        form_data.append('UserId', user_id)
        form_data.append('ProcessId', this.$route.params.rec_id)
        form_data.append('Format', 'png')
        form_data.append('ReqType', 8)
        form_data.append('DocType', 1)
        var file = this.dataURLtoFile(this.files[index].file, 'attach.png')
        form_data.append('Picture', file)

        this.axios.post('UploadFile', form_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.files[index].upload = 1
              self.files[index].ArchiveId = response.data.ArchiveId
              self.files[index].ImageName = response.data.ImageName
              var finish_all = true
              self.files.forEach(function (number) {
                if (number.upload != 1) {
                  finish_all = false
                }
              })
              if (finish_all) {
                self.files[0].upload = 1
                for (var i = 0; i < this.prices.length; i++) {
                  this.send_prices_to_server(i)
                }
              }
            } else {
              self.files[index].upload = 2
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_payment_types () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,

        }
        this.axios.post('GetPeymentTypeList', send_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.pay_types = response.data.data
            } else {

            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_payment_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          RequestId: this.$route.params.rec_id,

        }
        this.axios.post('GetPreFactorPeymentInfo', send_data, {})
          .then(response => {
            // self.send_signature(response.data.ArchiveId,response.data.ImageName);
            if (response.data.error == 0) {
              self.factor_price = Math.abs(response.data.TotalPrice)
              if (response.data.TotalPrice == 0) {
                bus.$emit('show_toast', [3000, this.$t('factorHasNoPrice')])

                self.$router.go(-1)
              }
            } else {

            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      dataURLtoFile (dataurl, filename) {
        var arr = dataurl.split(',')
          var mime = arr[0].match(/:(.*?);/)[1]
          var bstr = atob(arr[1])
          var n = bstr.length
          var u8arr = new Uint8Array(n)

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }

        return new File([u8arr], filename, { type: mime })
      },

      send_prices_to_server (index) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        // console.log();

        var attachment_array = []
        if (index == 0) {
          self.files.forEach(function (number) {
            var pre_obj = {
              ArchiveId: number.ArchiveId,
              ImageName: number.ImageName,
              Summary: '',
            }
            attachment_array.push(pre_obj)
          })
        }

        const send_data = {
          Attachments: attachment_array,
          UserId: user_id,
          Summary: '',
          PreFactorId: this.$route.params.rec_id,
          Price: this.prices[index].price,
          PeymentTypeId: this.prices[index].type_id,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddPreFactorPeyment', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.$router.go(-1)
            } else {
              bus.$emit('show_toast', [1500, this.$t('errorSendPays')])
            }
          }).catch(e => {
          this.errors.push(e)
        })
      }

    }
  }
</script>
